import { inject, provideAppInitializer } from '@angular/core';

import { TranslationStore } from './state/translation.store';

export const provideTranslationAppInitializer = () => provideAppInitializer(() => inject(TranslationStore).loadTranslations('common'));
